import {
  IApiaMultiple,
  TApiaSelectPossibleValue,
  TComponentSubmitValues,
} from 'src/types';
import ApiaForm from '../ApiaForm';
import { ISelectField, TSelectOptionsAsObj } from './SelectField';
import Field from '../constants/Field';
import { SelectField } from '.';
import propsStore from '../../store/propsStore/propsStore';

export type TOptionsAsObj = {
  [key: string]: string;
};
export interface IMultipleField extends ISelectField {
  setValue(value: string | number | string[]): IMultipleField | null;
  getSelectedOption(
    asObject: boolean,
  ): TSelectOptionsAsObj | (string | number)[][] | null;
  // setOptions(): void;
}

export default class MultipleField
  extends SelectField
  implements IMultipleField
{
  constructor(field: HTMLDivElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
  }

  setValue(value: string | number | string[]): IMultipleField | null {
    if (this.checkFieldExistsInDocument(this.fldId) && this.fldId !== null) {
      let values = [];
      const props = propsStore.getFieldProps(this.fldId);
      const currentValues = props.value as string[];
      if (Array.isArray(value)) {
        values = [...currentValues, ...value];
      } else {
        values.push(`${value}`);
      }
      super.setValue(values);
      return this;
    }
    return null;
  }

  getSelectedOption(
    asObject: boolean,
  ): TSelectOptionsAsObj | (string | number)[][] | null {
    if (this.checkFieldExistsInDocument(this.fldId) && this.fldId !== null) {
      const props = propsStore.getFieldProps(this.fldId);
      const possibleValues = (props.field as IApiaMultiple)
        .possibleValue as TApiaSelectPossibleValue[];
      const value: TComponentSubmitValues = props.value as string[];

      if (possibleValues && value !== undefined && Array.isArray(value)) {
        const selected = possibleValues.filter((possible) => {
          return value.includes(String(possible.value));
        });
        if (asObject) {
          const optionsResult = {} as TSelectOptionsAsObj;
          if (selected) {
            for (let i = 0; i < selected.length; i += 1) {
              optionsResult[selected[i].value as string] =
                selected[i].label || '';
            }
          }
          return optionsResult;
        }
        if (selected) {
          const arrResult = [];
          for (let i = 0; i < selected.length; i += 1) {
            let eleArr = [];
            if (this.valueType) {
              eleArr.push(selected[i].value as string);
            }
            eleArr.push(selected[i].label);
            arrResult.push(eleArr);
            eleArr = [];
          }
          return arrResult;
        }
      }
    }
    return null;
  }

  // setOptions(): void {}
}
